<template>
  <div>
    <!-- 盒子 -->
    <div class="border_parent">
      <b-row class="el-row-inline">
        <b-col :cols="screenSize" class="teacher-card" v-for="item in teacherList" :key="item.id">
          <a class="border_link" @click.prevent="linkNews(item.id)">
            <b-card class="el-card">
              <div class="content">
                <div class="content_left">
                  <el-image style="width: 200px; height: 280px" :src="item.photoUrl" fit="cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline image-error-icon"></i>
                    </div>
                  </el-image>
                </div>
                <div class="content_right">
                  <div class="content_name">{{ item.name }}</div>
                  <div class="content_discri">{{ item.description }}</div>
                </div>
              </div>
            </b-card>
          </a>
        </b-col>
      </b-row>
      <b-row type="flex" justify="center">
        <b-col>
          <div class="pagination">
            <b-pagination v-model="query.pageNum" :total-rows="total" :per-page="query.pageSize" :limit="3" align="center" size="sm" @input="handleCurrentChange">
              <template v-slot:first-text><span class="text-pag">First</span></template>
              <template v-slot:prev-text><span class="text-pag">Prev</span></template>
              <template v-slot:next-text><span class="text-pag">Next</span></template>
              <template v-slot:last-text><span class="text-pag">Last</span></template>
              <template v-slot:ellipsis-text>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </template>
              <template v-slot:page="{ page, active }">
                <b v-if="active">{{ page }}</b>
                <i v-else>{{ page }}</i>
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  name: "Team",
  data() {
    return {
      requestUrl: {
        getPage: "/researcher/page",
      },
      query: {
        name: "",
        pageNum: 1,
        pageSize: 6,
      },
      total: 0,
      teacherList: [],
      screenSize: 4,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.checkScreenSize(); // 初始化时检测一次页面尺寸
    window.addEventListener("resize", this.checkScreenSize); // 监听页面尺寸变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize); // 移除页面尺寸变化监听
  },
  methods: {
    // 页面尺寸变化
    checkScreenSize() {
      if (window.innerWidth < 1000) {
        this.screenSize = 6;
      } else {
        this.screenSize = 4;
      }
    },
    // 获取列表数据
    getData() {
      request
        .get(this.requestUrl.getPage, {
          params: this.query,
        })
        .then((res) => {
          if (res.code === "200") {
            this.teacherList = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error("获取失败");
          }
        });
    },

    //详情
    linkNews(id) {
      this.$router.push({
        name: "details",
        query: {
          researcherId: id,
          type: "3",
        },
      });
    },

    //修改页
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize;
      this.getData();
    },
    //修改每页条数
    handleCurrentChange(pageNum) {
      this.query.pageNum = pageNum;
      this.getData();
    },
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma, Arial;
  color: #313131;
}

h3 {
  color: #333;
  padding: 0;
  margin: 0, 0, 5px, 0;
  font-weight: normal;
}
.teacher-card {
  padding-bottom: 10px;
}
.text-pag {
  color: #002d71;
  font-weight: bold;
}

@media (max-width: 1000px) {
  .border_parent {
    width: 100%;
    margin: auto;
  }

  .content {
    display: grid;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 100%;
  }

  .content_right {
    width: 100%;
    display: grid;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .content_name {
    font-size: medium;
    font-weight: bold;
  }

  .content_discri {
    font-size: smaller;
  }
}

@media (min-width: 1000px) and (max-width: 1205px) {
  .border_parent {
    width: 80%;
    margin: auto;
  }

  .content {
    display: grid;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 100%;
  }

  .content_right {
    width: 100%;
    display: grid;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .content_name {
    font-size: medium;
    font-weight: bold;
  }

  .content_discri {
    font-size: smaller;
  }
}

@media (min-width: 1205px) {
  .border_parent {
    width: 80%;
    margin: auto;
  }

  .content {
    display: grid;
    justify-content: center;
    width: 100%;
  }

  .content:hover {
    cursor: pointer;
  }

  .content_left {
    width: 100%;
  }

  .content_right {
    width: 100%;
    display: grid;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .content_name {
    font-size: 30px;
    font-weight: bold;
  }

  .content_discri {
    font-size: medium;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-row-inline {
  display: flex;
  flex-wrap: wrap;
}

.el-card {
  min-width: 100%;
  height: 100%;
  margin: 0 auto;
}

.image-error-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

.border_link {
  text-decoration: none;
}
</style>
